import { render, staticRenderFns } from "./anforderungen-popover.vue?vue&type=template&id=62c78049&scoped=true"
import script from "./anforderungen-popover.vue?vue&type=script&lang=js"
export * from "./anforderungen-popover.vue?vue&type=script&lang=js"
import style0 from "./anforderungen-popover.vue?vue&type=style&index=0&id=62c78049&prod&scoped=true&lang=css"
import style1 from "./anforderungen-popover.vue?vue&type=style&index=1&id=62c78049&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c78049",
  null
  
)

export default component.exports